<template>
  <nav class="menu">
    <span class="title">{{$resx('MenuTitleText')}}</span>
    <ul>
      <li :class="{active:isSelectedPage('bookings')}">
        <a href="/bookings"><b>{{$resx('BookingsText')}}</b><span>{{$resx('BookingsSubMenuText')}}</span></a>
      </li>
      <li v-if="canShowNewsletter" :class="{active:isSelectedPage('newsletters')}">
        <a href="/newsletters"><b>{{$resx('NewslettersText')}}</b><span>{{$resx('HomeNewslettersSubMenuText')}}</span></a>
      </li>
      <li :class="{active:isSelectedPage('pepite')}">
        <a href="/pepite"><b>{{$resx('PepiteOfTheWeekText')}}</b><span>{{$resx('HomePepiteSubMenuText')}}</span></a>
      </li>
      <li :class="{active:isSelectedPage('faq')}">
        <a href="/faq"><b>{{$resx('FaqText')}}</b><span>{{$resx('FaqSubMenuText')}}</span></a>
      </li>
      <li v-if="canShowGreenScore" :class="{active:isSelectedPage('greenscore')}">
        <a href="/greenscore"><b>{{$resx('GreenScoreText')}}</b><span>{{$resx('FaqSubMenuText')}}</span></a>
      </li>
      <li :class="{active:isSelectedPage('documents')}">
        <a href="/documents"><b>{{$resx('DocumentsText')}}</b><span>{{$resx('DocumentsSubMenuText')}}</span></a>
      </li>
      <li :class="{active:isSelectedPage('webmastertools')}">
        <a href="/webmastertools"><b>{{$resx('WebmasterToolsText')}}</b><span>{{$resx('WebmasterToolsSubMenuText')}}</span></a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // condition pour afficher la page newsletter
    canShowNewsletter () {
      return this.$store.getters['app/canShowNewsletter']
    },
    // condition d'affichage de la page GreenScore
    canShowGreenScore () {
      return this.partner.currentCamping !== null && this.partner.currentCamping.isGreen
    }
  },
  methods: {
    // Retourne vrai si la page en paramètre est la page actuellement sélectionnée
    isSelectedPage (page) {
      return this.$store.state.app.page === page
    }
  }
}
</script>

<style lang="less">
  @import '../assets/variables.less';

  .menu {

    .title
    {
      display:block;
      font-weight: @fontBlack;
      margin-bottom:1em;
      font-size:1.5em;
    }

    ul
    {
      width: 100%;
      max-width: 50em;
      margin: 0 auto;
    }

  li {
    position: relative;
    padding-left: 1em;
    margin-bottom: 1.5em;
    opacity: .5;

    &.active
    {
      opacity: 1;
    }

    &:before
      {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0;
        top: 25%;
        width: .3em;
        height: .3em;
        border-radius: 50%;
        background-color: @gold;
      }
    }

    a {
      color: @white;
      text-decoration: none;

      b
      {
        display: block;
        color: @gold;
        font-style: italic;
        font-size: 1.5em;
        margin-bottom: .25em;
      }

      span {
        text-decoration: underline;
      }

      &:hover
      {
        span
        {
          color:@gold;
        }
      }
    }
  }
</style>
